export const part_view_strings = {
  // Field labels
  manufacturerLabel: "Manufacturer",
  frameLabel: "Frame",
  partNumberLabel: "Part Number",
  turbineModelLabel: "Turbine Model",
  quantityLabel: "Quantity",
  serialNumberLabel: "Serial Number",
  upgradeDesignationsLabel: "Upgrades",
  castingNumberLabel: "Casting Number",
  matchedHardwareLabel: "Matched Hardware",
  totalFactoredFiredHoursLabel: "Total Factored Fired Hours",
  totalFactoredFiredStartsLabel: "Total Factored Fired Starts",
  emergencyTripsLabel: "Emergency Trips",
  timesRefurbishedLabel: "Times Refurbished",
  statusLabel: "Status",
  conditionLabel: "Condition",
  partTypeLabel: "Part Type",
  dateListedLabel: "Date Listed",
  dateSoldLabel: "Date Sold",
  tagsLabel: "Tags",
  addressLabel: "Address",
  updatedLabel: "Listing Last Updated",

  // File information
  pedigreeFilesLabel: "Pedigree Files",
  shopReleaseFilesLabel: "Shop Release Files",
  flowTestFilesLabel: "Flow Test Files",
  dimensionalInspectionFilesLabel: "Dimensional Inspection Files",
  ndeReportFilesLabel: "NDE Report Files",
  photoFilesLabel: "Photo Files",
  file: "file",
  files: "files",

  // Raw data section
  rawDataLabel: "RAW DATA (admin only)",

  // Standard states
  available: "Available",
  notAvailable: "Not Available",
};
